"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./reset.css");
require("./main.css");
require("./strava-fonts.css");
const mithril_1 = __importDefault(require("mithril"));
const Index_1 = __importDefault(require("./components/Index"));
mithril_1.default.mount(document.getElementById('root'), Index_1.default);
